import { copyDeep } from '@/shared'
import {
    IPayloadCreateInquiryAdvisor,
    IStateStoreInquiryAdvisor,
    ITypeParamsDetailInquiryAdvisor,
    IPayloadDeleteInquiryAdvisor,
    ITypePayloadAnswerInquiryAdvisor
} from '@/modules/advisor/modules/inquiry/shared/@types'
import { HttpStatusCode, TypeNotify } from '@/shared/enums'
import { NotificationCustom } from '@/shared/function'
import InquiryAdvisorService from '@/modules/advisor/modules/inquiry/services'

export const defaultStateInquiryAdmin: IStateStoreInquiryAdvisor = {
    data: {}
}

const state = () => copyDeep(defaultStateInquiryAdmin)

const getters = {
    getDataInquiry(state: IStateStoreInquiryAdvisor) {
        return state.data
    }
}

const mutations = {
    setDataInquiryAdvisor(state: IStateStoreInquiryAdvisor, payload: any) {
        state.data = payload
    }
}

const actions = {
    async getDataInquiry(
        { commit }: any,
        payload: IPayloadCreateInquiryAdvisor
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await InquiryAdvisorService.apiGetInquiryAdvisor(
                payload
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataInquiryAdvisor', data.data)
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async getDataDetailInquiry(
        { commit, dispatch }: any,
        params: ITypeParamsDetailInquiryAdvisor
    ) {
        commit('popup/setLoading', true, { root: true })
        commit('popup/setIsNotPageLoading', true, {
            root: true
        })
        try {
            const res = await InquiryAdvisorService.apiGetInquiryDetailAdvisor(
                params
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataInquiryAdvisor', data.data)
                return data.data
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
            commit('popup/setIsNotPageLoading', false, { root: true })
        }
    },
    async createInquiry(
        { commit, dispatch }: any,
        payload: IPayloadCreateInquiryAdvisor
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await InquiryAdvisorService.apiCreateInquiryAdvisor(
                payload
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                NotificationCustom({
                    type: TypeNotify.success,
                    message: data.message
                })
                return true
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async createInquiryAnswer(
        { commit, dispatch }: any,
        payload: ITypePayloadAnswerInquiryAdvisor
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res =
                await InquiryAdvisorService.apiCreateInquiryAnswerAdvisor(
                    payload
                )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                NotificationCustom({
                    type: TypeNotify.success,
                    message: data.message
                })
                dispatch('getDataDetailInquiry', { id: payload?.inquiry_id })
                return true
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async deleteInquiryAdvisor(
        { commit, dispatch }: any,
        payload: IPayloadDeleteInquiryAdvisor
    ) {
        commit('popup/setLoading', true, { root: true })
        commit('popup/setIsNotPageLoading', true, { root: true })
        try {
            const res = await InquiryAdvisorService.apiDeleteInquiryAdvisor(
                payload
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                NotificationCustom({
                    type: TypeNotify.success,
                    message: data.message
                })
                commit('popup/hidePopup', null, { root: true })
                commit('setDataInquiryAdvisor', {
                    refreshData: true
                })
                dispatch('signupAuth/countNotifyAdvisor', true, { root: true })
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
            commit('popup/setIsNotPageLoading', false, { root: true })
        }
    },
    async updateStatusReadInquiryAdvisor(
        { commit, dispatch }: any,
        id: number
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res =
                await InquiryAdvisorService.apiUpdateStatusReadInquiryAdvisor(
                    id
                )
            if (res.status === HttpStatusCode.ok) {
                dispatch('signupAuth/countNotifyAdvisor', true, { root: true })
                return
            }
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
